/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![PaintbrushThickPlusIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABmElEQVR4nOWUO0sDQRSFU9mIiIWICNpY2xvELqDZvY8VJvcmighia2djE7Ex/gjt1X9hEAXBQrCJYGdsLLQTVCIbdzWP2eyIsXJgmp295zv3zCOT+ffDGDOALPtAUgeWe2SthN/6FgyyVpC10TErfQMASb0LQPrgLEBUzCPJUTh9lsU294hDFveNMConcWQtWwTK34DCvBVAuucivmsr/nSoh8i6gay3nc6dNhlIdpLEsStvqRFJNpdbGXSKJRYHkncXAJCsOwl3ZP4KrAWXToDkwE0cC6vRBr1hUNCfxSVb6QCSWuRoLSk2tM8XDMSkAoD0KSwIguVx+7rYIYFuuiSUQdLj6KhdGGOGXSGeVxpprrGeIUk1ERA6R9a7GAJgpoHlEknPkyBA8vhlMPrWs4v8UmkqhoQnKYJdLRgz2grzuTjreWaiLQEXgA1CJFlguY5hSXXOgORO9AZAx+J/mpmn3/KqMwRAZ3wuzsXvTFiceglZT3t24vtmsgUSb+z2ryPqPF3AcoIsz9HDVuorwHX8PYCkasv8AxMAnWQ3FgdzAAAAAElFTkSuQmCC)
 */
export const PaintbrushThickPlusIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M15.35 7.24C15.9 6.67 16 5.8 16 5a3 3 0 1 1 3 3c-.8 0-1.67.09-2.24.65a1.5 1.5 0 0 0 0 2.11l.4.4.46.43c.25.25.12.66-.18.84A3 3 0 0 0 16 15v.5a.5.5 0 0 1-.5.5H15c-.43 0-.84.1-1.21.26a.56.56 0 0 1-.63-.1L6.91 9.91 4.3 12.54a1 1 0 0 0 0 1.42l2.17 2.17.83-.84a1 1 0 0 1 1.42 1.42l-.84.83.59.59 1.83-1.84a1 1 0 0 1 1.42 1.42l-1.84 1.83.17.17a1 1 0 0 0 1.42 0c.2-.2.6-.07.69.22a3 3 0 0 0 .56 1c.09.11.09.27-.02.36a3 3 0 0 1-4.06-.16l-5.76-5.76a3 3 0 0 1 0-4.24L6.9 7.09h.01l.97-.97a3 3 0 0 1 4.24 0l1.12 1.12a1.5 1.5 0 0 0 2.1 0Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M19 14a1 1 0 0 1 1 1v3h3a1 1 0 0 1 0 2h-3v3a1 1 0 0 1-2 0v-3h-3a1 1 0 1 1 0-2h3v-3a1 1 0 0 1 1-1Z"
        className={colorClass}
      />
    </svg>
  );
};
